import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./activities.css";
import { postApi } from "../../services/http-clients";

const ComposeModal = ({ id, show, handleClose, succesError }) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  /* -------------------- State -------------------- */
  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [sending, setSending] = useState(false);

  const [toValue, setToValue] = useState("");
  const [subjectValue, setSubjectValue] = useState("");

  const [contentValue, setContentValue] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    to_email: "",
  });

  const addChip = () => {
    const value = inputValue.trim();
    if (!value) return;

    setChips((prev) => [...prev, value]);
    setInputValue("");
  };

  const removeChip = (index) => {
    setChips((prev) => prev.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      addChip();
    }
  };

  /* -------------------- API Calls -------------------- */
  const sendMail = async () => {
    if (sending) return;

    setSending(true);

    const bodyData = {
      to_email: toValue,
      cc_emails: chips,
      subject: subjectValue,
      body: contentValue,
    };

    try {
      const response = await postApi(
        `${apiUrl}vendor/activity/${id}`,
        bodyData,
      );

      if (response.status === 400) {
        const validationTemp = {
          to_email: "",
          cc_emails: "",
          subject: "",
          body: "",
        };

        Object.entries(response.data.error).forEach(([key, value]) => {
          if (key in validationTemp) {
            validationTemp[key] =
              Array.isArray(value) && value.length ? value[0] : "";
          }
        });

        setErrorMsg(validationTemp);
      }

      succesError(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  /* -------------------- UI -------------------- */
  return (
    <Modal
      show={show}
    //   onHide={handleClose}
      centered
      dialogClassName="compose-modal"
    >
      <div className="compose-box">
        {/* Header */}
        <div className="compose-header d-flex justify-content-between align-items-center">
          <span className="fs-13 fw-500">New Message</span>
          <button onClick={handleClose} className="icon-btn">
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="compose-content">
          {/* To */}
          <div className="compose-row">
            <label className="compose-label">To</label>
            <input
              type="text"
              value={toValue}
              onChange={(e) => setToValue(e.target.value)}
              placeholder="Enter here"
              className="compose-input fs-13 fw-600 textcolor flex-grow-1"
            />
          </div>

          <span className="text-danger fs-12">{errorMsg.to_email}</span>

          {/* CC */}
          <div className="compose-row">
            <label className="compose-label">CC</label>

            <div className="chip-input-wrapper flex-grow-1">
              {chips.map((chip, index) => (
                <span key={index} className="chip">
                  {chip}
                  <span
                    className="chip-close"
                    onClick={() => removeChip(index)}
                  >
                    ×
                  </span>
                </span>
              ))}

              <input
                type="text"
                className="chip-real-input fs-13 fw-600 textcolor"
                placeholder={chips.length ? "" : "Enter here"}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>

          {/* Subject */}
          <div className="compose-row">
            <label className="compose-label">Subject</label>
            <input
              type="text"
              value={subjectValue}
              onChange={(e) => setSubjectValue(e.target.value)}
              placeholder="Enter here"
              className="compose-input fs-13 fw-600 textcolor flex-grow-1"
            />
          </div>

          {/* Editor */}
          <ReactQuill
            theme="snow"
            className="compose-editor"
            value={contentValue}
            onChange={setContentValue}
            style={{ minHeight: "200px" }}
          />
        </div>

        {/* Footer */}
        <div className="compose-footer d-flex justify-content-end">
          <Button onClick={sendMail} className="send-btn" disabled={sending}>
            {sending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </>
            ) : (
              "Send"
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ComposeModal;
